export default __webpack_public_path__ + "static/media/icon-qr-passcoopeuch-appgallery.35d6b8e3.png";